import React, { useContext, useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import theme from '../theme/theme';
import { globalStore } from '../state/store';
import { getLeagueByLID, updateLeague, getLeaguesByUID } from '../services/leagueService';
import { Button, Box, CircularProgress, Divider, Grid, InputAdornment, 
         Step, Stepper, StepLabel, TextField, Typography, useMediaQuery, 
         Avatar} from "@mui/material";
import { CircularProgressCP, Header, SignInUp } from '../components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTag, faCheckCircle, faMinusCircle, faPlusCircle, faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import cp_dark from '../assets/img/cp_dark.png'
import { createLeague } from '../services/leagueService';

function League() {

  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
  const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));

  const styles = {
    hiddenBox: {
      display: 'none',
    },
    resizeBox: { 
      [theme.breakpoints.only('xs')]: { width: '320px' },
      [theme.breakpoints.up('sm')]: { width: '480px' },
      marginBottom: '20px',
    },
    lineItem: {
      marginRight: '10px', 
    }
  }

  const navigate = useNavigate();
  const [state, dispatch] = useContext(globalStore);
  const [leagname, setLeagname] = React.useState({valid: false, value: ''});
  const [joinLeague, setJoinLeague] = React.useState(null);
  const [loading, setLoading] = React.useState({ league: false, package: false })
  const [billPackage, setBillPackage] = React.useState({ name: 'League:', price: 2.99 })
  const [billUsers, setBillUsers] = React.useState({ name: 'Participants:', qty: 10, price: 9.25})
  const { type, lid } = useParams();
  const steps = ['create'].includes(type) ? ['Personal', 'League', 'Package'] : 
                ['join'].includes(type) ? ['Personal', 'League', 'Complete'] : 
                                            ['Personal', 'League'];

  useEffect(() => {

    //console.log("UE", lid, joinLeague)

    if(lid.length > 15 && !Boolean(joinLeague) && Boolean(state.user) && Boolean(state.user.email)) {
      console.log("UE joinLeague", joinLeague)
      getLeagueByLID(lid)
      .then((l) => {        
        console.log("leaguex", l)
        let newJoinLeague = l
        newJoinLeague.lid = lid
        newJoinLeague.isInvited = (l.invited.includes(state.user.email))
        newJoinLeague.isPlayer = (l.players.includes(state.user.uid))
        newJoinLeague.error = 
          !newJoinLeague.isInvited && newJoinLeague.isLocked ? 
              <span style={{color: theme.palette.error.main}}>
                <Typography align="center">You are not invited to this private league</Typography>
                <Typography align="center" sx={{fontWeight: '700', mb:3}}>Contact the league creator</Typography>
              </span> :
          newJoinLeague.isPlayer ? 
              <span style={{color: theme.palette.error.main}}>
                <Typography align="center">You are already a player in this league</Typography>
                <Typography align="center" sx={{fontWeight: '700', mb:3}}>Go to your dashboard to access the league</Typography>
              </span> : 
              null
          newJoinLeague.confirmed = false
        setJoinLeague(newJoinLeague)
        setBillPackage({ 
          name: newJoinLeague.isLocked ? 'Join private league' : 'Join public league:', 
          price: newJoinLeague.isLocked ? 0.00 : 4.99
        })
        setBillUsers(null)
      })
      .catch((err) => {
        console.log("err", err)
      })
    }
  }, [lid, state.user])

  const handleLeagnameUpdate = (newVal) => {
    //const isValid = /\b\w+\@\w+\.\w+(?:\.\w+)?\b/.test(newVal)
    const isValid = newVal.length > 2 && newVal.length < 20
    setLeagname({ valid: isValid, value: newVal })
  }

  const handleSubmitLeague = () => {
    setLoading({league: true, package: false});
    let l = Boolean(joinLeague) ?
        {
          lid: joinLeague.lid,
          createdBy: joinLeague.createdBy,
          invited: joinLeague.invited,
          isLocked: joinLeague.isLocked,
          name: joinLeague.name,
          name_lower: joinLeague.name_lower,
          maxPlayers: joinLeague.maxPlayers,
          logoURL: joinLeague.logoURL,
          players: [...joinLeague.players, state.user.uid]  // Use spread operator to create new array
        }
        :
        { 
          name: leagname.value, 
          createdBy: state.user.displayName, 
          maxPlayers: 1,
          logoURL: "/static/media/cp_dark.7d6c940d22ab6ffd3455.png", 
          players: [state.user.uid]
        }

    let confirmedJoinLeague = joinLeague;
    confirmedJoinLeague.confirmed = true;

    dispatch({ type: "ADD_LEAGUE", payload: l });
    dispatch({ type: "CHANGE_LEAGUEACTIVE", payload: l })
    setJoinLeague(confirmedJoinLeague)
  }

  const handleSubmitPackage = () => {
    setLoading({league: false, package: true});
    // TODO - handle payment
    // TODO - create league - attach ID to league object and update

    //let newLeague = state.leagues.filter((l) => l._id === state.league)[0]
    let newLeague = state.league

    if(Boolean(joinLeague)) {
      // Updating a league
      updateLeague(newLeague)
      .then((l) => {
        console.log("updated league", l)
        getLeaguesByUID(state.user.uid) // pull leagues for user
        .then((leagues) => {
  
          //let l = Boolean(leagues) && leagues.length > 0 ? leagues[0] : null

          console.log("leagues", leagues)
  
          dispatch({ type: "INIT_LEAGUES", payload: leagues });
          dispatch({ type: "CHANGE_LEAGUEACTIVE", payload: leagues.filter((le) => le.lid === l.lid)[0] }); // asign active league
          dispatch({ type: "CHANGE_RANKEDLIST", payload: [] }); // update RankedList
          //dispatch({ type: "LOAD_PREDICTION", payload: pred});
          //dispatch({ type: "LOAD_PREDICTIONANSWER", payload: predAnswer});
          
          console.log("leagues", leagues)
          console.log("state", state)
          setLoading(false)
          navigate('/dashboard') // navigate to dashboard 
  
        }).catch((err) => { console.log("errLSx2", err); setLoading(false) })
      })

    } else {
      // Creating a new league
      newLeague.maxPlayers = billUsers.qty;
      newLeague.isLocked = true;
      newLeague.name_lower = newLeague.name.toLowerCase();
      newLeague.managers = [state.user.uid]

      createLeague(newLeague)
      .then((l) => {

        dispatch({ type: "CHANGE_LEAGUEACTIVE", payload: l });
        navigate('/dashboard')
        setLoading(false)

      }).catch((err) => { console.log("errLeague", err); setLoading(false) })
    }

  }

  return (
    <div>

      <Header page="League" />

      <Grid container direction="column" sx={{pt:10}}>

        <Grid item>

            <Grid container direction="column" alignItems="center">
                
                <Grid item>
                    <Box sx={{mt: 5, width: isLgUp ? '800px' : isMdUp ? '600px' : isSmUp ? '450px' : '320px'}}>
                    <Stepper activeStep={!Boolean(state.user) ? 0 : Boolean(state.user) ? 1 : 2} alternativeLabel>
                        {steps.map((label) => {
                        //const stepProps = {};
                        //const labelProps = {};                
                        return (
                            <Step key={label}/* {...stepProps}*/>
                            <StepLabel /* {...labelProps}*/>
                                <Typography sx={{fontWeight: '700', color: theme.palette.grey[800]}}>{label}</Typography>
                            </StepLabel>
                            </Step>
                        );
                        })}
                    </Stepper>
                    </Box>
                </Grid>

                <Grid item>
                    <Box sx={{py: 6}}>
                        {
                        // Step 1: If you don't have a user yet, go signup or login 
                        !Boolean(state.user) ?
                        <>
                          <SignInUp variant={['create'].includes(type) ? "create" : lid} />
                        </>
                        :// Step 2: Now create or join a league
                        Boolean(state.user) && 
                        (!Boolean(state.league) || 
                         !Boolean(state.league.maxPlayers) || 
                         (Boolean(joinLeague) && !joinLeague.confirmed)
                        ) ?
                        <>                          
                          <Grid container direction="column" justifyContent="center" alignItems="center" sx={{mt:2}}>
                            {Boolean(joinLeague) ?
                            // Join league
                            <Grid item sx={styles.resizeBox}>

                              <Typography variant="h4" align="center">{joinLeague.name}</Typography>
                              <Typography color="text.secondary" align="center">{joinLeague.createdBy}</Typography>

                            </Grid>
                            :
                            // Create league
                            <Grid item sx={styles.resizeBox}>
                              <TextField
                              //autoFocus
                              fullWidth
                              variant="outlined"
                              id="leagname"
                              placeholder="League name..."
                              label="League name"
                              name="leagname"
                              autoComplete="leagname"
                              value={leagname.value}
                              onChange={e => handleLeagnameUpdate(e.target.value)}
                              InputProps={{
                                startAdornment: (
                                <InputAdornment position="start">
                                    <FontAwesomeIcon 
                                    icon={leagname.valid ? faCheckCircle : faTag} 
                                    color={leagname.valid ? theme.palette.success.main : theme.palette.primary.main} />
                                </InputAdornment>
                                ),
                              }}
                              />
                            </Grid>
                            }
                            <Grid item container justifyContent={"center"} alignItems={"center"} sx={styles.resizeBox}>
                              <Grid item sx={{mt:Boolean(joinLeague) ? 1 : 3, mb:3}}> 
                              <Avatar src={cp_dark} sx={{width: '150px', height: '150px'}} />
                              </Grid>
                            </Grid>
                            {Boolean(joinLeague) && Boolean(joinLeague.error) ?
                              // Trying to join a league but having an error 
                                joinLeague.error
                            :''
                            }
                            <Grid item sx={styles.resizeBox}>
                              <Button
                              onClick={handleSubmitLeague}
                              type="submit"
                              disableElevation
                              variant="contained"
                              fullWidth
                              disabled={((loading.league || !leagname.valid) && !Boolean(joinLeague)) ||
                                (Boolean(joinLeague) && Boolean(joinLeague.error))}
                              style={{padding: '5px 15px', fontWeight: '600', fontSize: '17px', marginBottom: '5px'}}>
                              {loading.league ?
                              <>Submitting...&nbsp;&nbsp;<CircularProgress size={15} /></>
                              : Boolean(joinLeague) ?
                              "Join league"
                              : "Submit"}
                              </Button>
                            </Grid>
                            {Boolean(joinLeague) ?
                              // When there is an error, show a button to head back to the dashboard
                              <Grid item sx={styles.resizeBox}>
                                <Button
                                onClick={() => navigate('/dashboard')}
                                variant="text"
                                fullWidth
                                >
                                  <FontAwesomeIcon icon={faArrowLeft} />&nbsp;&nbsp;Go back home</Button>
                              </Grid>
                            :''
                            }
                          </Grid>
                        </>
                        :
                        // If you create a league - pay for it
                        Boolean(state.user) && Boolean(state.league) && 
                        Boolean(state.league.maxPlayers) && 
                          (state.league.maxPlayers === 1 || 
                           (state.league.maxPlayers > 1 && Boolean(joinLeague))) ?
                        <>
                        <Grid container direction="column" justifyContent="center" alignItems="center">
                          <Grid item sx={styles.resizeBox}>
                            <Grid container direction="row" justifyContent={'space-between'}>
                              <Grid>
                                <Grid container direction="row">
                                  <Grid item style={styles.lineItem}>{billPackage.name}</Grid>
                                  <Grid item style={{color: theme.palette.primary.main, fontWeight: '900', fontSize: '18px'}}>
                                    {leagname.value}
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid>${billPackage.price}</Grid>
                            </Grid>
                          </Grid>
                          <Grid item sx={styles.resizeBox}>
                            <Divider />
                          </Grid>
                          {Boolean(billUsers) && Boolean(billUsers.price) ?
                          <Grid item sx={styles.resizeBox}>
                            <Grid container direction="row" justifyContent={'space-between'}>
                              
                              <Grid>
                                <Grid container direction="row">
                                  <Grid sx={styles.lineItem}>{billUsers.name}</Grid>
                                  <Grid>
                                    <FontAwesomeIcon icon={faMinusCircle} 
                                    style={{color: billUsers.qty > 1 ? theme.palette.primary.main : theme.palette.grey[500], 
                                    fontSize: '25px', cursor: billUsers.qty > 1 ? 'pointer' : 'default',
                                    margin: '0px 10px 0px 10px', '&:hover': {color: billUsers.qty > 1 ? theme.palette.secondary.main : theme.palette.grey[500]}}}
                                    onClick={e => setBillUsers({
                                          name: 'Users',
                                          qty: billUsers.qty > 10 ? billUsers.qty - 10 : 1,
                                          price: billUsers.qty > 10 ? (billUsers.qty - 10) * 0.9 : 1
                                      })} />
                                  </Grid>
                                  <Grid>
                                    {billUsers.qty}
                                  </Grid>
                                  <Grid>
                                    <FontAwesomeIcon icon={faPlusCircle} 
                                    style={{color: theme.palette.primary.main, fontSize: '25px', cursor: 'pointer',
                                    margin: '0px 10px 0px 10px', '&:hover': {color: theme.palette.secondary.main}}}
                                    onClick={e => setBillUsers({
                                      name: 'Users',
                                      qty: billUsers.qty > 1 ? billUsers.qty + 10 : 10,
                                      price: billUsers.qty > 1 ? (billUsers.qty + 10) * 0.9 : 9
                                    })}
                                    //disabled={qtyUsers < 11} 
                                    />
                                  </Grid>
                                </Grid>
                                
                              </Grid>
                              <Grid sx={{marginLeft: '10px'}}>${billUsers.price}</Grid>
                              
                            </Grid>
                          </Grid>
                          :''
                          }
                          {Boolean(billUsers) && Boolean(billUsers.price) ?
                          <Grid item sx={styles.resizeBox}>
                            <Divider />
                          </Grid>
                          :''
                          }
                          <Grid item sx={styles.resizeBox}>
                            <Grid item sx={styles.resizeBox}>
                              <Grid container direction="row" justifyContent={'space-between'}>
                                <Grid><Typography sx={{fontWeight: '700'}}>Total due today</Typography></Grid>
                                <Grid><Typography sx={{fontWeight: '700'}}>${
                                (Boolean(billPackage) && billPackage.price ? billPackage.price : 0) + 
                                (Boolean(billUsers) && billUsers.price ? billUsers.price : 0)}</Typography></Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item sx={styles.resizeBox}>
                            <Button
                            onClick={handleSubmitPackage}
                            type="submit"
                            disableElevation
                            variant="contained"
                            fullWidth
                            style={{padding: '5px 15px', fontWeight: '600', fontSize: '17px', marginBottom: '5px'}}>
                            {loading.package ?
                              <>Submitting...&nbsp;&nbsp;<CircularProgress size={15} /></>
                            :(Boolean(billPackage) && billPackage.price ? billPackage.price : 0) + 
                             (Boolean(billUsers) && billUsers.price ? billUsers.price : 0)  === 0 ?
                            "Continue" : 
                            "Agree and Pay"}
                            </Button>
                          </Grid>
                        </Grid>                        
                        </>
                        :
                        <CircularProgressCP />}
                    </Box>
                </Grid>
            </Grid>

        </Grid>

      </Grid>

    </div>
  );
}

export default League;